export enum ValidationDataTypes {
	String,
	Number,
	Boolean,
	Object,
	DateTime,
}
